<template>
  <div>
  <div class="container">
    <h1>Craniosacrale Energiebalance</h1>

    <div class="highlight-blockquote cranio-halsbasis">
      <div class="highlight-blockquote-text-container">
      <!-- <blockquote > -->
        <p class="quote">
          Für unser Auge meist nicht sichtbar, herrscht in allen Teilen unseres Körpers ein ständiger Fluss 
      an chemischen Wechselwirkungen und mechanischen Spannungen. Wie jedes komplexe System versucht auch 
      der Organismus all diese Bewegungen und Veränderungen in einem Gleichgewicht zu halten. Dieses 
      individuelle Gleichgewicht heißt Gesundheit!
        </p>
        <div class="align-right">
        - Zitat Zeitschrift zu Osteopathie
        </div>
      <!-- </blockquote> -->
      </div>
    </div>

    <p>Jedliche Form von Krankheit und Schmerz hat ihre Ursache in einem gestörten Gleichgewicht im Körper. 
      Die betroffenen Regionen weisen Veränderungen in der Gewebequalität und Gewebebeweglichkeit auf, 
      auch schon lange bevor es zu spürbaren Problemen kommt. In der Craniosacralen Energiebalance werden 
      mittels feiner Wahrnehmung und kleinen, sanften Bewegungen die betreffenden Strukturen korrigiert.</p>

    <p>Damit ist die Craniosacrale Energiebalance eine non-invasive Methode, welche die Mobilität aller 
      Körperstrukturen wiederherstellt und die Selbstheilungsprozesse im Organismus aktiviert. Es ist eine 
      sanfte und schmerzlose Methode die Blockaden in Gelenken, Bindegeweben und Muskeln aufspürt und 
      ausbalanciert (sanft reguliert).</p>

    <p>Die Craniosacrale Energiebalance ist eine energetische Therapieform, die sich aus der Osteopathie 
      entwickelt hat. Eine Anwendung ist grundsätzlich bei allen Wirbeltieren möglich, in Spezialfällen 
      kontaktieren Sie mich gerne.</p>

    <p>Meine Arbeit am Individuum (Mensch, Pferd, Hund, Tier...) ist geprägt von Intuition und Gefühl 
      aufbauend auf Fachwissen und Erfahrung.</p>
    <div id="uebersicht" class="flex-container-uebersicht">
    <router-link :to="{ path: 'energiebalance-mensch' }" class="desktop link"><img src="../assets/img/cranio-auswahl/mensch.jpg" width="350" alt="Craniosacrale Energiebalance für Menschen" /></router-link> 
    <router-link :to="{ path: 'energiebalance-pferd' }" class="desktop link"><img src="../assets/img/cranio-auswahl/pferde.jpg" width="350" alt="Craniosacrale Energiebalance für Pferde" /></router-link> 
    <router-link :to="{ path: 'energiebalance-hund' }" class="desktop link"><img src="../assets/img/cranio-auswahl/hunde.jpg" width="350" alt="Craniosacrale Energiebalance für Hunde" /></router-link> 
    
    <router-link :to="{ path: 'energiebalance-mensch' }" class="mobile align-right"><img src="../assets/img/cranio-auswahl/mensch.jpg" alt="" />Craniosacrale Energiebalance für Menschen</router-link> 
    <router-link :to="{ path: 'energiebalance-pferd' }" class="mobile align-right"><img src="../assets/img/cranio-auswahl/pferde.jpg" alt="" />Craniosacrale Energiebalance für Pferde</router-link> 
    <router-link :to="{ path: 'energiebalance-hund' }" class="mobile align-right"><img src="../assets/img/cranio-auswahl/hunde.jpg" alt="" />Craniosacrale Energiebalance für Hunde</router-link> 

    </div>
    <blockquote><p>„Alles kann nichts muss“</p></blockquote>

    <p>Der Körper bestimmt das Tempo und den Ablauf der Anwendung. Heilung ist ein Prozess, der Körper 
      benötigt Zeit um sich an die neue Situation anzupassen. Insofern macht es Sinn den restlichen 
      Tag nach einer Anwendung ruhig anzugehen.</p>
  </div>


    <div class="highlight cranio">
      <div class="container">
      <p>Oft werde ich kontaktiert wenn Menschen bereits „alles versucht“ haben ihre eigenen körperlichen 
        Problem oder die ihrer Tiere in den Griff zu bekommen. An diesem Punkt kann die Craniosacrale 
        Energiebalance dem Körper tatsächlich den entschiedenen Schwung in die richtige Richtung geben. 
        Das Gleichgewicht im Körper wird wiederhergestellt und damit auch die Selbstheilungskräfte angeregt.</p>

      <p>Viele meiner langjährigen Kunden wissen aber auch die Craniosacrale Arbeit als Profilaxe zu schätzen. 
        Die Craniosacrale Arbeit spürt Veränderungen in den Körperstrukturen auf BEVOR sie zu Problemen werden 
        und Schmerzen bereiten. Die eigene Körperwahrnehmung spielt hier ebenfalls eine entschiedene Rolle.</p> 
    </div>
    </div>
<div class="container">
    <p>Auch wenn es in unserer schnelllebigen Welt oft so suggestiert wird:</p> 

    <p><b>Es ist NICHT normal, dass einem etwas weh tut! Schmerz ist immer ein Hilferuf des Körpers. Schenken Sie dem Gehör.</b></p>

    <p>Bitte beachten Sie: Ich stelle keine Diagnosen und eine Anwendung ersetzt keinen Arztbesuch!</p>
</div>
  </div>
</template>

<script>
export default {
  name: "Cranio",
  watch: {
      '$route' (to, from) {
        console.log("Route changed");
      }

  },
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    }
  },
   metaInfo() {
        return { 
            title: "Craniosacrale Energiebalance für Mensch und Tier - Katharina Herda",
            meta: [
              { name: 'description', content: 'Katharina Herda verfolgt einen ganzheitlichen Ansatz zur Wiederherstellung des natürlichen Gleichgewichts im Körper von Menschen, Pferden, Hunden, aber auch anderen Tieren' },
              { property: 'og:title', content: "Craniosacrale Energiebalance für Mensch und Tier - Katharina Herda"},
              { property: 'og:description', content: 'Katharina Herda verfolgt einen ganzheitlichen Ansatz zur Wiederherstellung des natürlichen Gleichgewichts im Körper von Menschen, Pferden, Hunden, aber auch anderen Tieren'},
              { property: 'og:image', content: 'src/img/assets/cranio-auswahl/mensch.jpg'},
              { property: 'og:url', content: 'www.herda.at/energiebalance'}

            ]
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Cranio.vue